export function datePhraseForDay(s: string):Date { //Build for all platform. iOS has bug in string => Date
    let r = s.split("-");
    let n = r.map(v => Number(v));
    return new Date(n[0], n[1], n[2]);
}